(() => {
  function initialize(root) {
    if (root.dataset.baseAInitialized) return;
    root.dataset.baseAInitialized = 'true';
    const countries = root.querySelectorAll('[data-base-a-country-selector]');
    countries.forEach(details => {
      details.addEventListener('toggle', () => details.querySelector('summary').setAttribute('aria-expanded', String(details.open)));
      details.addEventListener('keydown', event => { if (event.key === 'Escape') { details.open = false; details.querySelector('summary').focus(); } });
      document.addEventListener('pointerdown', event => { if (!details.contains(event.target)) details.open = false; });
    });
    const input = root.querySelector('[data-base-a-search-input]');
    const panel = root.querySelector('[data-base-a-search-panel]');
    const search = root.querySelector('.base-a-header-utilities__search');
    if (!input || !panel) return;
    let closing = false;
    const show = () => { if (!closing) { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); } };
    const hide = (restoreFocus = false) => {
      closing = true;
      if (restoreFocus) input.focus();
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      closing = false;
    };
    input.addEventListener('focus', show);
    input.addEventListener('click', show);
    input.addEventListener('keydown', event => {
      if (event.key === 'ArrowDown') {
        show();
        const first = panel.querySelector('a');
        if (first) { event.preventDefault(); first.focus(); }
      }
    });
    root.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !panel.hidden) { event.preventDefault(); hide(true); }
    });
    root.addEventListener('focusout', event => {
      if (event.relatedTarget && !search.contains(event.relatedTarget)) hide();
    });
    document.addEventListener('pointerdown', event => {
      if (!search.contains(event.target)) hide();
    });
  }
  const mount = (context = document) => context.querySelectorAll('[data-base-a-header-utilities]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), {once:true});
  else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
